import { Input, Progress, Select, Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";
import { sectors } from "../../data/admin";

const { Text, Title } = Typography;

const companyStats = [
  { label: "Active Sectors", value: "3", trend: "Wheels live, Health and Homes staged" },
  { label: "Internal Teams", value: "12", trend: "2 teams expanding coverage" },
  { label: "Open Exceptions", value: "46", trend: "11 require same-day review" },
];

const portfolioRows = [
  { key: "1", sector: "Wheels", owner: "Marketplace Ops", status: "Live", openItems: 18, throughput: "KES 92.4M", readiness: 78 },
  { key: "2", sector: "Health", owner: "Care Ops", status: "Staging", openItems: 9, throughput: "3.9k requests", readiness: 34 },
  { key: "3", sector: "Homes", owner: "Property Ops", status: "Staging", openItems: 7, throughput: "126 deals", readiness: 34 },
];

export default function CompanyOverviewScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel
        eyebrow="Company Layer"
        title="SERID Internal Overview"
        actions={
          <div className="flex flex-wrap gap-2">
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All sectors" },
                { value: "live", label: "Live only" },
                { value: "staging", label: "Staging only" },
              ]}
              style={{ width: 140 }}
            />
            <Input.Search placeholder="Search teams or sectors" style={{ width: 240 }} />
          </div>
        }
      >
        <Text type="secondary">
          Shared employee tooling belongs here: cross-sector visibility, internal controls, staffing, and platform health.
        </Text>
      </GlassPanel>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {companyStats.map((item) => (
          <GlassPanel key={item.label} bodyClassName="py-4">
            <Text className="block text-[11px]! uppercase tracking-[0.18em] text-black/45 dark:text-white/45">{item.label}</Text>
            <Title level={4} className="mb-1! mt-2!">{item.value}</Title>
            <Text type="secondary">{item.trend}</Text>
          </GlassPanel>
        ))}
      </div>

      <GlassPanel eyebrow="Portfolio" title="Sector Status">
        <Table
          rowKey="key"
          pagination={false}
          dataSource={portfolioRows}
          columns={[
            {
              title: "Sector",
              dataIndex: "sector",
              render: (value: string) => {
                const sector = sectors.find((item) => item.shortLabel === value);
                return (
                  <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-md bg-black/[0.04] dark:bg-white/[0.05]" style={sector ? { color: sector.accent } : undefined}>
                      {sector?.icon}
                    </div>
                    <div>
                      <Text strong>{value}</Text>
                      <Text type="secondary" className="block">{sector?.summary}</Text>
                    </div>
                  </div>
                );
              },
            },
            { title: "Owner", dataIndex: "owner" },
            {
              title: "Status",
              dataIndex: "status",
              render: (value: string) => <Tag color={value === "Live" ? "success" : "processing"}>{value}</Tag>,
            },
            { title: "Open Items", dataIndex: "openItems" },
            { title: "Volume", dataIndex: "throughput" },
            {
              title: "Readiness",
              dataIndex: "readiness",
              render: (value: number) => <Progress percent={value} size="small" />,
            },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
